import React from 'react';

import './index.scss';

// eslint-disable-next-line react/prop-types
export default function TextField({ children }) {
  return (
    <div className="text-field">{ children }</div>
  );
}
